import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=b27f125a&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\008-QLK_FE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b27f125a')) {
      api.createRecord('b27f125a', component.options)
    } else {
      api.reload('b27f125a', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=b27f125a&", function () {
      api.rerender('b27f125a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/sale/components/Detail.vue"
export default component.exports